export const QUEST_PROGRESS_REQUEST = 'Quest Progress Request'
export const QUEST_NEXT_CARD_REQUEST = 'Quest Next Card Request'
export const QUEST_ANSWER_CARD = 'Quest Answer Card'
